import * as React from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";

import { Button } from "@mui/material";
import * as Constants from '../../Constants'

export default function DemosTable() {
  const [demos, setDemos] = React.useState([]);
  const [err, setErr] = React.useState(null);
  const [refresh, setRefresh] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(true);

  function deleteDemo(id) {
    setDemos(demos.filter((demo)=>{
      return demo.id !== id
    }))
    setRefresh(refresh + 1)
    if (id) {
      axios
        .delete(`/delete_demo/${id}`)
        .then((res)=>{
          setRefresh(refresh + 1)
        })
        .catch((err) => {
          setErr(err.response.data);
        });
    }
  }

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 60,
    },
    {
      field: "firstName",
      headerName: "First Name",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "lastName",
      headerName: "Last Name",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "org",
      headerName: "Organization",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "email",
      headerName: "E-mail",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "found",
      headerName: "Found",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "timestamp",
      headerName: "Timestamp",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "Action",
      disableColumnMenu: true,
      width: 200,
      sortable: false,
      renderCell: (params) => {
        const onClickDelete = (e) => {
          e.stopPropagation();
          deleteDemo(params.row.id);
        };

        return (
          
            <Button size="small" variant="contained" onClick={onClickDelete}>
              Delete
            </Button>
          
        );
      },
    }
  ];

  React.useEffect(() => {
    axios.defaults.withCredentials = true 
    axios
      .get(`${Constants.API_URL}/get_demos`)
      .then((res) => {
        setDemos(res.data.demos);
        setIsLoading(false);
      })
      .catch((err) => {
        setErr(err.message);
      });
  }, []);

  return (
    <React.Fragment>
      {err ? (
        <p>{err}</p>
      ) : (
        <div
          id="m"
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "flex-end",
          }}
        >
          <Box sx={{ height: 400, width: "100%" }}>
            <DataGrid
              // getRowHeight={() => "auto"}
              loading={isLoading}
              rows={demos}
              columns={columns}
              
              pageSize={10}
              rowsPerPageOptions={[10]}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              initialState={{
                sorting: {
                  sortModel: [{ field: "id", sort: "desc" }],
                },
              }}
            />
          </Box>
        </div>
      )}
    </React.Fragment>
  );
}
